import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import Loader from '../../components/Loader/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { categoryWiseProduct, postStoreCart, getCartLogin, AddWishlist, RemoveWishlist } from '../../apiservices/ApiServices';
import { FaArrowRight } from "react-icons/fa6";
import ProductCard from '../../components/ProductCard/ProductCard';
import { useCartWishlist } from '../CartWishlistContext';
import useScrollRestoration from '../useScrollRestoration';

const Accessories = () => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [wishlistsTot, setWishlistsTot] = useState(1);
    const [msg, setMsg] = useState('');
    const [ismsg, setisMsg] = useState(false);
    const [selectedItem, setSelectedItem] = useState('all');
    const [totalProductCount, setTotalProductCount] = useState(0);
    const { brandId, modalId, slug } = useParams();
    const { cart, setCart, wishlist, isLogin, setIsLogin, addToCart, toggleWishlist } = useCartWishlist();

    useScrollRestoration(!isLoading);

    const categoryWiseProducts = async (postdata) => {
        try {
            const res = await categoryWiseProduct(postdata);
            setData(res.data.data);

            const total = res?.data?.data?.reduce(
                (sum, item) => sum + (item.product_count || 0),
                0
            );
            setTotalProductCount(total);
            setLoading(false);
            setisMsg(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setMsg(error.response?.data?.message || 'Error fetching products');
            setData(error.response?.data?.data || []);
        }
    };

    useEffect(() => {
        setLoading(true);

        let postData = {
            brand_id: brandId,
            model_id: modalId,
            plan_slug: slug,
        };
        categoryWiseProducts(postData);
    }, [brandId, modalId, slug])

    const postCartData = async (postdata) => {
        try {
            const res = await postStoreCart(postdata);
        } catch (error) {
            console.log(error);
        }
    };

    const handleCartUpdate = (updatedCart) => {
        const formattedCart = Object.entries(updatedCart).map(([sku_id, quantity]) => ({
            sku_id: parseInt(sku_id, 10),
            quantity
        }));

        localStorage.setItem("cart", JSON.stringify(formattedCart));
        setCart(formattedCart);
    };

    const initializeQuantities = (items) => {
        const initialQuantities = {};
        items.forEach(item => {
            initialQuantities[item.sku_id] = item.cart_quantity || 1;
        });

        handleCartUpdate(initialQuantities);
    };

    const updateLoginCartAPI = async () => {
        try {
            const res = await getCartLogin();
            initializeQuantities(res.data.data);
        } catch (error) {
        }
    };

    useEffect(() => {
        if (localStorage.getItem('userToken')) {
            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
            if (!storedCart?.length) {
                updateLoginCartAPI();
            }
            else {
                postCartData(storedCart);
                updateLoginCartAPI();
            }
        }
        setLoading(true);
    }, [])

    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, []);

    const updateProduct = (skuId, field, value) => {
        setData(prevData =>
            prevData.map(category => ({
                ...category,
                products: category.products.map(product =>
                    product.sku_id === skuId
                        ? { ...product, [field]: value }
                        : product
                )
            }))
        );
    };

    const addToWishlist = async (skuid) => {
        setLoadings(true);
        const postdata = {
            sku_id: skuid,
        };
        try {
            const res = await AddWishlist(postdata);
            //toast.success(res.data.message);

            updateProduct(skuid, "is_wishlist", true);

            setWishlistsTot(wishlistsTot + 1);
            setLoadings(false);

        } catch (error) {
            console.log(error);
            setLoadings(false);
        }
    };

    const removeWishlist = async (skuid) => {
        setLoadings(true);
        try {
            const res = await RemoveWishlist(skuid);
            //toast.success(res.data.message);

            updateProduct(skuid, "is_wishlist", false);

            setWishlistsTot(wishlistsTot + 1);
            setLoadings(false);
        } catch (error) {
            console.log(error);
            setLoadings(false);
        }
    };

    return (
        <>
            <Header CartTot={cart.length} WishTot={wishlistsTot} toast={toast} />
            <ToastContainer />
            {isLoading ? (<Loader />) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <Link to={'/find-your-model'}>Find Your Model</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">Accessories</span>
                        </div>
                    </div>

                    <section id='filterListData'>
                        <Container>
                            <div id="compatbar">
                                <div className="compat-count">{totalProductCount} Compatible Products Found</div>
                            </div>

                            {/* <div id="filters">
                                <button onClick={() => setSelectedItem('all')} className={selectedItem == 'all' ? 'active pills' : 'pills'}>All ({totalProductCount})</button>
                                {data.map((item) => {
                                    return (
                                        <button key={item.slug} onClick={() => setSelectedItem(item.slug)} className={selectedItem == item?.slug ? 'active pills' : 'pills'}>{item?.name} ({item?.product_count})</button>
                                    );
                                })}
                            </div> */}

                            {data.map((dataitem) => {
                                return (
                                    <section id='prods' key={dataitem.id || dataitem.slug} className="prod-section">
                                        <div className="sec-head">
                                            <h2 className="sec-title">Choose Your <span className="teal">{dataitem.name}</span></h2>
                                            <Link to={slug ? `/product/categories/${dataitem.slug}/${brandId}/${modalId}/${slug}` : `/product/categories/${dataitem.slug}/${brandId}/${modalId}`} className="cat-link">View All <FaArrowRight /></Link>
                                        </div>
                                        <div className='product-box'>
                                            <Row>
                                                {dataitem?.products?.map((item, index) => (
                                                    <Col md={3} key={`pro_${item.sku_id}_ids${index}`}>
                                                        <ProductCard
                                                            PlanName={item?.eligible_plan_name}
                                                            PlanContent={item?.thumbnail_description}
                                                            Name={item.name}
                                                            SkuID={item.sku_id}
                                                            ImgUrl={item?.media_list[0]?.media_url}
                                                            Offer={item.discount_per}
                                                            Price={item.price}
                                                            OldPrice={item.actual_price}
                                                            ProductSlug={item.slug}
                                                            ProductLabel={item?.product_label}
                                                            Quantitys={item.quantity}
                                                            Brands={item?.brands?.name}
                                                            Model={item?.model?.name}
                                                            Cart={cart}
                                                            Wishlist={wishlist}
                                                            ToggleWishlist={toggleWishlist}
                                                            addToCart={addToCart}
                                                        />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                        <div className='buttonboxs resdb'>
                                            <Link to={slug ? `/product/categories/${dataitem.slug}/${brandId}/${modalId}/${slug}` : `/product/categories/${dataitem.slug}/${brandId}/${modalId}`} className="btn btn-green">View All <FaArrowRight /></Link>
                                        </div>
                                    </section>
                                );
                            })}
                        </Container>
                    </section>
                </>
            )}

            <Footer toast={toast} />
        </>
    )
}

export default Accessories